import { createStore } from 'effector';
import { SavedCard } from './entities';

export const $savedCards = createStore<SavedCard[]>([]);

export const $placeSavedCards = createStore<SavedCard[]>([]);
